<div class="popup" [formGroup]="notesForm">
  <div class="popup-header">
    <div class="header-left">
      <h2 class="header-title">{{ 'quotations_and_orders.line_notes.title' | translate }}</h2>
    </div>
    <div class="close-icon" (click)="close()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="#232529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>

  <div class="product-info">
    <div class="product-image">
      <img [class]="!data.productImage ? 'no-image' : ''" [src]="productImage" alt="">
    </div>
    <div class="product-name" *ngIf="data?.productName">{{ data.productName }}</div>
  </div>

  <div class="input-group">
    <label class="input-label">{{ 'quotations_and_orders.line_notes.label' | translate }}</label>
    <div class="input-field">
      <textarea
        class="notes-textarea"
        [attr.placeholder]="'quotations_and_orders.line_notes.placeholder' | translate"
        formControlName="note"
      ></textarea>
    </div>
  </div>

  <div class="button-group" *ngIf="data?.editable; else viewerActions">
    <button class="btn btn-delete" *ngIf="hasExistingNote" (click)="delete()">
      {{ 'common.delete' | translate }}
    </button>
    <span *ngIf="!hasExistingNote"></span>
    <button class="btn btn-save" (click)="save()">
      {{ 'companies.update' | translate }}
    </button>
  </div>

  <ng-template #viewerActions>
    <div class="button-group">
      <span></span>
      <button class="btn btn-save" (click)="close()">
        {{ 'common.close' | translate }}
      </button>
    </div>
  </ng-template>
</div>
